export const LESSON_COMPLETION =
  document.documentElement.dataset.lessonCompletion === "true";
